<template>
    <div class="q-pa-md">
        <div class="row">
            <div class="col-12">
                <!-- <div class="text-center">
                    <q-icon name="mdi-minus" size="md" style="cursor: pointer;" color="primary"
                        @click="AnteriorPagina"></q-icon>
                    {{ page }} /{{ numPages }}
                    <q-icon name="mdi-plus" size="md" style="cursor: pointer;" color="primary"
                        @click="SiguientePagina"></q-icon>
                </div> -->
            </div>
            <div style="width: 100%">
                <pdf ref="pdf" :src="pdfBase64" :page="page" :rotate="rotate" @progress="loadedRatio = $event"
                    @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
            </div>
        </div>
    </div>
</template>

<script>
import { generarCotizacionPDF } from '../PDF/CotizacionPDF.JS' // Ajusta esta ruta
import { QSpinnerClock } from 'quasar'
import pdf from 'vue-pdf';

export default {
    components: {
        pdf: pdf
    },
    name: 'VisualizadorPDF',
    data() {
        return {
            pdfUrl: null,
            pdfDoc: null,
            loadedRatio: 0,
            page: 1,
            numPages: 0,
            rotate: 0,
            logoBase64: ''
        }
    },
    async mounted() {
        const logoURL = require('../../assets/logo_top.png')
        this.logoBase64 = await this.cargarImagenComoBase64(logoURL);
    },
    created() {
        this.Iniciales();
    },
    computed: {
        pdfBase64() {
            return this.$store.state.auth.storeBase64Cotizacion;
        },
        objetoPostCotizacion() {
            return this.$store.state.auth.objetoPostCotizacion;
        },
    },
    methods: {
        async Iniciales() {
            this.$q.loading.show({
                spinner: QSpinnerClock,
                spinnerColor: 'primary',
                spinnerSize: 90,
                message: 'Consultando, espere..',
            })
            await this.VerCotizacion();
            this.$q.loading.hide()
        },

        async VerCotizacion() {
            try {
                let base64 = ''
                const logoURL = require('../../assets/logo_top.png')
                this.logoBase64 = await this.cargarImagenComoBase64(logoURL);

                console.log('base', this.logoBase64)
                base64 = await generarCotizacionPDF(this.logoBase64, this.objetoPostCotizacion);
                this.$store.state.auth.storeBase64Cotizacion = 'data:application/pdf;base64,' + base64.split(',')[1];
            } catch (error) {
                console.log(error)
            }
        },
        generarNombreArchivo(nombre) {
            const fecha = new Date()
            const yyyy = fecha.getFullYear()
            const mm = String(fecha.getMonth() + 1).padStart(2, '0')
            const dd = String(fecha.getDate()).padStart(2, '0')

            // Limpia espacios del nombre
            const nombreLimpio = nombre.replace(/\s+/g, '')
            return `Cotizacion_${nombreLimpio}_${yyyy}-${mm}-${dd}.pdf`
        },
        SiguientePagina() {
            let paginas = this.numPages;
            if (this.page < paginas) {
                this.page++;
            } else {
                // this.page = 1;
            }
        },

        AnteriorPagina() {
            let paginas = this.numPages;
            if (this.page > paginas) {
                this.page--;
            } else {
                this.page = 1;
            }
        },
        cargarImagenComoBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.onload = function () {
                    const canvas = document.createElement('canvas')
                    canvas.width = this.width
                    canvas.height = this.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(this, 0, 0)
                    const dataURL = canvas.toDataURL('image/png')
                    resolve(dataURL)
                }
                img.onerror = reject
                img.src = url
            })
        },
    }
}
</script>